/**
 * @file Automatically generated by barrelsby.
 */

export * from './pipes.module';
export * from './translate-plural.pipe';
export * from './separate-symbol.pipe';
